import { getSiblings } from "./getSiblings";
import { closest } from "./closest";
import getParents from "./getParents";

const DomHelper = {
  getParents,
  getSiblings,
  closest
};

export default DomHelper;
